// テーブル管理
import commonClass from "./commonClass";

export default class gridClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._recordHeight = 26;
  }

  // 初期化用関数
  _init() {
    var cls = this;
  }

  // 「種類」カラムのラベルhtml生成
  _genTypeHtml(txt) {
    if (txt === '特集') {
      return '<span class="c-grid_type is-spc">' + txt + '</span>';
    } else if (txt === '単体') {
      return '<span class="c-grid_type is-sgl">' + txt + '</span>';
    }
  }
  // 「緊急度」カラムのラベルhtml生成
  _genUrgencyHtml(txt) {
    if (Number(txt) < 0) {
      return '<span class="c-grid_txt_red">' + txt + '</span>';
    } else {
      return txt;
    }
  }
  // 「増加」カラムのラベルhtml生成
  _genGainHtml(txt) {
    if (Number(txt) > 0) {
      return '<span class="c-grid_txt_red">' + txt + '</span>';
    } else {
      return txt;
    }
  }
  // 「特典」カラムの「表示」リンクhtml生成
  _genBenefitHtml(flg) {
    if (flg) {
      return '★';
    } else {
      return '-';
    }
  }
  // 「アンケート」カラムの「表示」リンクhtml生成
  _genSurveyHtml(hrefTxt) {
    if (hrefTxt === '') {
      return '-';
    } else {
      return '<a href="' + hrefTxt + '">表示' + '</a>';
    }
  }
  // 「配信」カラムのリンクhtml生成
  _genDeliveryHtml(deliveryArr) {
    if (deliveryArr) {
      return '<a href="' + deliveryArr[1] + '">' + deliveryArr[0] + '</a>';
    } else {
      return '-';
    }
  }
  // 「PV/CV」カラムのhtml生成
  _genPvCvHtml(pvcvArr) {
    return '<span class="c-grid_txt_pvcd">' + pvcvArr[0] + '<br>' + pvcvArr[1] + '</span>';
  }

  // チェックボックスの追加
  _genCheckbox(isChecked) {
    var check = isChecked ? "checked" : "";
    return '<div class="c-grid_check"><input class="js-lst-ch" type="checkbox"' + check + '><span></span></div>';
  }

  // セレクトボックスの追加
  _genSelect() {
    var slctHtml;
    var slctTxt = [
      '原稿A',
      '原稿B',
      '原稿C',
      '原稿D',
      '原稿E'
    ];
    for (var i = 0; i < slctTxt.length; i++) {
      if (i === 0) slctHtml = '<option selected></option>'
      slctHtml = slctHtml + '<option value="' + slctTxt[i] + '">' + slctTxt[i] + '</option>';
    }
    return '<div class="c-grid_select"><select>' + slctHtml + '</select></div>';
  }


  // ダッシュボード：リードテーブル
  _initDashboardReadGrid(rcdObj) {
    var cls = this;
    var $tgt = $('.js-grid_dashboard_read');

    $tgt.w2grid({
      name: 'grid_dashboard_read',
      fixedBody: false,
      recordHeight: cls._recordHeight,
      columns: [
        { field: 'client', caption: 'クライアント', size: '230px', frozen: true },
        { field: 'id', caption: 'ID', size: '60px' },
        {
          field: 'type',
          caption: '種類',
          size: '60px',
          render: function(rcd) {
            return cls._genTypeHtml(rcd.type);
          }
        },
        { field: 'pjname', caption: '案件名', size: '50%' },
        { field: 'pjcharge', caption: '営業担当', size: '90px', sortable: true },
        { field: 'editcharge', caption: '編集担当', size: '90px' },
        { field: 'compdate', caption: '企画終了予定日', size: '100px' },
        {
          field: 'urgency',
          caption: '緊急度',
          size: '60px',
          render: function(rcd) {
            return cls._genUrgencyHtml(rcd.urgency);
          }
        },
        {
          field: 'gain',
          caption: '増加',
          size: '40px',
          render: function(rcd) {
            return cls._genGainHtml(rcd.gain);
          }
        },
        {
          field: 'benefit',
          caption: '特典',
          size: '40px',
          render: function(rcd) {
            return cls._genBenefitHtml(rcd.benefit);
          }
        },
        {
          field: 'survey',
          caption: 'アンケート',
          size: '80px',
          render: function(rcd) {
            return cls._genSurveyHtml(rcd.survey);
          }
        },
        {
          field: 'delivery',
          caption: '配信',
          size: '40px',
          render: function(rcd) {
            return cls._genDeliveryHtml(rcd.delivery);
          }
        },
        {
          field: 'pvcv',
          caption: 'PV/CV',
          size: '60px',
          render: function(rcd) {
            return cls._genPvCvHtml(rcd.pvcv);
          }
        },
        { field: 'contents', caption: 'コンテンツ', size: '80px' }
      ],
      records: rcdObj
    });
  }

  // ダッシュボード：セミナーテーブル
  _initDashboardSeminarGrid(rcdObj) {
    var cls = this;
    var $tgt = $('.js-grid_dashboard_seminar');

    $tgt.w2grid({
      name: 'grid_dashboard_seminar',
      fixedBody: false,
      recordHeight: cls._recordHeight,
      columns: [
        { field: 'id', caption: 'ID', size: '60px', frozen: true },
        {
          field: 'type',
          caption: '種類',
          size: '60px',
          render: function(rcd) {
            return cls._genTypeHtml(rcd.type);
          }
        },
        { field: 'pjname', caption: '案件名', size: '50%' },
        { field: 'pjcharge', caption: '営業担当', size: '80px', sortable: true },
        { field: 'editcharge', caption: '編集担当', size: '80px', sortable: true },
        { field: 'eventdate', caption: '開催日', size: '90px' },
        { field: 'warranty', caption: '保証', size: '50px' },
        { field: 'registration', caption: '登録', size: '50px' },
        { field: 'submission', caption: '提出', size: '50px' },
        { field: 'shortfall', caption: '未達', size: '50px' },
        { field: 'remainday', caption: '残日', size: '50px' },
        {
          field: 'urgency',
          caption: '緊急度',
          size: '60px',
          render: function(rcd) {
            return cls._genUrgencyHtml(rcd.urgency);
          }
        },
        {
          field: 'gain',
          caption: '増加',
          size: '40px',
          render: function(rcd) {
            return cls._genGainHtml(rcd.gain);
          }
        },
        {
          field: 'benefit',
          caption: '特典',
          size: '40px',
          render: function(rcd) {
            return cls._genBenefitHtml(rcd.benefit);
          }
        },
        {
          field: 'survey',
          caption: 'アンケート',
          size: '80px',
          render: function(rcd) {
            return cls._genSurveyHtml(rcd.survey);
          }
        },
        {
          field: 'delivery',
          caption: '配信',
          size: '40px',
          render: function(rcd) {
            return cls._genDeliveryHtml(rcd.delivery);
          }
        },
        {
          field: 'pvcv',
          caption: 'PV/CV',
          size: '60px',
          render: function(rcd) {
            return cls._genPvCvHtml(rcd.pvcv);
          }
        },
        { field: 'contents', caption: 'コンテンツ', size: '80px' }
      ],
      // sortData: [
      //   { field: 'pjcharge', direction: 'dsc' }
      // ],
      records: rcdObj
    });
  }

  // ダッシュボード：キャンペーンテーブル
  _initDashboardCampaignGrid(rcdObj) {
    var cls = this;
    var $tgt = $('.js-grid_dashboard_campaign');

    $tgt.w2grid({
      name: 'grid_dashboard_campaign',
      fixedBody: false,
      recordHeight: cls._recordHeight,
      columns: [
        { field: 'id', caption: 'ID', size: '60px', frozen: true },
        {
          field: 'type',
          caption: '種類',
          size: '60px',
          render: function(rcd) {
            return cls._genTypeHtml(rcd.type);
          }
        },
        { field: 'pjname', caption: '案件名', size: '50%' },
        { field: 'pjcharge', caption: '営業担当', size: '80px', sortable: true },
        { field: 'editcharge', caption: '編集担当', size: '80px', sortable: true },
        { field: 'compdate', caption: '募集期間終了予定日', size: '100px' },
        { field: 'warranty', caption: '保証', size: '50px' },
        { field: 'registration', caption: '登録', size: '50px' },
        { field: 'submission', caption: '提出', size: '50px' },
        { field: 'shortfall', caption: '未達', size: '50px' },
        { field: 'remainday', caption: '残日', size: '50px' },
        {
          field: 'urgency',
          caption: '緊急度',
          size: '60px',
          render: function(rcd) {
            return cls._genUrgencyHtml(rcd.urgency);
          }
        },
        {
          field: 'gain',
          caption: '増加',
          size: '50px',
          render: function(rcd) {
            return cls._genGainHtml(rcd.gain);
          }
        },
        {
          field: 'benefit',
          caption: '特典',
          size: '50px',
          render: function(rcd) {
            return cls._genBenefitHtml(rcd.benefit);
          }
        },
        {
          field: 'survey',
          caption: 'アンケート',
          size: '50px',
          render: function(rcd) {
            return cls._genSurveyHtml(rcd.survey);
          }
        },
        {
          field: 'delivery',
          caption: '配信',
          size: '50px',
          render: function(rcd) {
            return cls._genDeliveryHtml(rcd.delivery);
          }
        },
        {
          field: 'pvcv',
          caption: 'PV/CV',
          size: '60px',
          render: function(rcd) {
            return cls._genPvCvHtml(rcd.pvcv);
          }
        },
        { field: 'contents', caption: 'コンテンツ', size: '80px' }
      ],
      // sortData: [
      //   { field: 'pjcharge', direction: 'dsc' }
      // ],
      records: rcdObj
    });
  }


  // ダッシュボード：キャンペーンテーブル
  _initPjListGrid(rcdObj) {
    var cls = this;
    var $tgt = $('.js-grid_pjlist');

    $tgt.w2grid({
      name: 'grid_pjlist',
      fixedBody: false,
      recordHeight: cls._recordHeight,
      columns: [
        { field: 'client', caption: 'クライアント', size: '240px', frozen: true },
        { field: 'id', caption: 'ID', size: '60px' },
        {
          field: 'type',
          caption: '種類',
          size: '60px',
          render: function(rcd) {
            return cls._genTypeHtml(rcd.type);
          }
        },
        { field: 'pjname', caption: '案件', size: '50' },
        { field: 'pjcharge', caption: '案件担当者', size: '80px' },
        { field: 'compdate', caption: '企画終了予定日', size: '100px' },
        {
          field: 'benefit',
          caption: '特典',
          size: '50px',
          render: function(rcd) {
            return cls._genBenefitHtml(rcd.benefit);
          }
        },
        { field: 'submission_goal', caption: '提出数/目標数', size: '100px' },
        { field: 'registration', caption: '登録数', size: '60px' },
        { field: 'maildelivery', caption: 'メール配信数', size: '80px' }
      ],
      records: rcdObj
    });
  }
}

// .fillのポリフィル
if (!Array.prototype.fill) {
  Object.defineProperty(Array.prototype, 'fill', {
    value: function(value) {

      // Steps 1-2.
      if (this == null) {
        throw new TypeError('this is null or not defined');
      }

      var O = Object(this);

      // Steps 3-5.
      var len = O.length >>> 0;

      // Steps 6-7.
      var start = arguments[1];
      var relativeStart = start >> 0;

      // Step 8.
      var k = relativeStart < 0 ?
        Math.max(len + relativeStart, 0) :
        Math.min(relativeStart, len);

      // Steps 9-10.
      var end = arguments[2];
      var relativeEnd = end === undefined ?
        len : end >> 0;

      // Step 11.
      var final = relativeEnd < 0 ?
        Math.max(len + relativeEnd, 0) :
        Math.min(relativeEnd, len);

      // Step 12.
      while (k < final) {
        O[k] = value;
        k++;
      }

      // Step 13.
      return O;
    }
  });
}